import { useState, useCallback, useRef } from 'react'
import { useAndrzej } from '@/hooks/useAndrzej'
import { useActionCable } from '@/hooks/useActionCable'
import { AndrzejFab } from './AndrzejFab'
import { AndrzejSidebar } from './AndrzejSidebar'
import type { CableMessage } from '@/types/andrzej'

export function AndrzejWidget() {
  const andrzej = useAndrzej()
  const [isClosing, setIsClosing] = useState(false)
  const sidebarRef = useRef<HTMLElement>(null)

  useActionCable(andrzej.conversationId, (data) => {
    andrzej.handleCableMessage(data as CableMessage)
  })

  const handleToggle = useCallback(() => {
    if (andrzej.isOpen) {
      // Closing: animate out, then unmount
      setIsClosing(true)
      const el = sidebarRef.current
      if (el) {
        el.addEventListener('animationend', () => {
          setIsClosing(false)
          andrzej.close()
        }, { once: true })
      } else {
        setIsClosing(false)
        andrzej.close()
      }
    } else {
      andrzej.open()
    }
  }, [andrzej.isOpen, andrzej.close, andrzej.open])

  if (!andrzej.isAuthenticated) return null

  const showSidebar = andrzej.isOpen || isClosing

  return (
    <>
      <AndrzejFab onClick={handleToggle} isOpen={andrzej.isOpen && !isClosing} />
      {showSidebar && (
        <AndrzejSidebar
          ref={sidebarRef}
          isClosing={isClosing}
          messages={andrzej.messages}
          isThinking={andrzej.isThinking}
          avatarState={andrzej.avatarState}
          welcomeMessage={andrzej.welcomeMessage}
          showWelcome={andrzej.showWelcome}
          conversations={andrzej.conversations}
          isConvosPanelOpen={andrzej.isConvosPanelOpen}
          conversationId={andrzej.conversationId}
          photoPreviews={andrzej.photoPreviews}
          messagesEndRef={andrzej.messagesEndRef}
          onClose={handleToggle}
          onSend={andrzej.sendMessage}
          onAddPhoto={andrzej.addPhoto}
          onRemovePhoto={andrzej.removePhoto}
          onNewConversation={andrzej.newConversation}
          onToggleConversations={andrzej.toggleConversationsPanel}
          onSelectConversation={andrzej.selectConversation}
        />
      )}
    </>
  )
}
